import { Reveal, Overline } from "./Reveal";

const PILLARS = [
  { n: "01", title: "Strategy", desc: "Understand the business, the customer, the offer, and the growth objective." },
  { n: "02", title: "Creative", desc: "Develop content and messaging capable of capturing attention." },
  { n: "03", title: "Technology", desc: "Build the infrastructure required to capture and manage opportunities." },
  { n: "04", title: "Automation", desc: "Reduce friction and improve speed-to-lead." },
  { n: "05", title: "Optimization", desc: "Measure what works and improve the system over time." },
];

export default function Why() {
  return (
    <section id="why" data-testid="why-section" className="border-t border-line px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Overline>09 — Why Polemikoi</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
            Strategy before tactics. <span className="text-zinc-500">Systems before noise.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
            Most businesses don&rsquo;t need another disconnected marketing service. They need
            someone who understands how the pieces work together.
          </p>
        </Reveal>

        <div className="mt-20">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.06}>
              <div
                data-testid={`why-pillar-${p.n}`}
                className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-t border-line py-10 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-[120px_1fr_1.2fr] md:gap-12"
              >
                <span className="font-mono text-sm text-zinc-600 transition-colors duration-500 group-hover:text-crimson">{p.n}</span>
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white transition-transform duration-500 group-hover:translate-x-2 md:text-4xl">
                  {p.title}
                </h3>
                <p className="col-span-2 mt-2 max-w-xl text-sm leading-relaxed text-zinc-400 md:col-span-1 md:mt-0 md:text-base">{p.desc}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-line" />
        </div>
      </div>
    </section>
  );
}
